import { PStyled, SmallStyled } from 'approot/shared/styles/typography.style';
import {
  ActivityBuilderDrawerContent,
  ActivityBuilderDrawerHeader,
  ActivityBuilderDrawerWrapper,
} from '../activity-builder-drawer';
import { useActivityBuilderContext } from '../activity-builder.context';
import { SettingsDrawerEmptyState } from './settings-drawer.style';

import emptyImage from './component-select-slide.png';

const SettingsDrawerEmpty = () => {
  const { closeDrawer } = useActivityBuilderContext();

  return (
    <ActivityBuilderDrawerWrapper>
      <ActivityBuilderDrawerHeader
        title=""
        hasBorderBottom={false}
        onClose={closeDrawer}
      />
      <ActivityBuilderDrawerContent>
        <SettingsDrawerEmptyState>
          <img src={emptyImage} alt="" />
          <PStyled textAlignCenter>
            Select a component on the activity to view its editing controls
          </PStyled>
          <SmallStyled textAlignCenter>
            There is no component selected
          </SmallStyled>
        </SettingsDrawerEmptyState>
      </ActivityBuilderDrawerContent>
    </ActivityBuilderDrawerWrapper>
  );
};

export default SettingsDrawerEmpty;
